import React from 'react';
import { Pane, Paneset } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import useBarcode from '../../../../hooks/Barcode/useBarcode';
import SerialNumberForm from './components/SerialNumberForm';
import BarcodeGeneratorSettings from './components/BarcodeGeneratorSettings';

function BarcodeGeneralSettings() {
  const { lastIndex } = useBarcode();

  return (
    <Paneset>
      <Pane
        id="inventory-plugin-template-customFields-list-pane"
        paneTitle={
          <FormattedMessage
            id="ui-plugin-inventory-templates.barcodeGeneralSettings.pane.paneTitle"
            defaultMessage="Barcode general settings"
          />
        }
        fluidContentWidth
        centeredContent
      >
        <BarcodeGeneratorSettings />
        <SerialNumberForm lastIndex={lastIndex} />
      </Pane>
    </Paneset>
  );
}

export default BarcodeGeneralSettings;
